import { Reply, Forward, MessagesSquare, Paperclip } from "lucide-react";
import type { I18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { SourceAction } from "../types";

export interface EmailActionsConfig {
  onReply?: () => void;
  onForward?: () => void;
  onOpenThread?: () => void;
  onShowAttachments?: () => void;
}

export function buildEmailActions(cfg: EmailActionsConfig, i18n: I18n): SourceAction[] {
  return [
    {
      id: "reply",
      label: i18n._(msg`Rispondi`),
      icon: <Reply className="h-3.5 w-3.5" />,
      variant: "primary",
      disabled: !cfg.onReply,
      onSelect: () => cfg.onReply?.(),
    },
    {
      id: "forward",
      label: i18n._(msg`Inoltra`),
      icon: <Forward className="h-3.5 w-3.5" />,
      disabled: !cfg.onForward,
      onSelect: () => cfg.onForward?.(),
    },
    {
      id: "open-thread",
      label: i18n._(msg`Apri thread`),
      icon: <MessagesSquare className="h-3.5 w-3.5" />,
      disabled: !cfg.onOpenThread,
      onSelect: () => cfg.onOpenThread?.(),
    },
    {
      id: "attachments",
      label: i18n._(msg`Allegati`),
      icon: <Paperclip className="h-3.5 w-3.5" />,
      disabled: !cfg.onShowAttachments,
      onSelect: () => cfg.onShowAttachments?.(),
    },
  ];
}
